import { createSelector } from 'reselect'

import { NAME } from './reducer'

const byIdSelector = (state) => state[NAME].byId
export const getResultIds = (state) => state[NAME].allKeys

export const getResultById = createSelector([byIdSelector], (byId) => (id) =>
  byId[id] || null
)

export const getResults = createSelector(
  [getResultById, getResultIds],
  (byId, allKeys) => allKeys.map(byId)
)

export const getResultsIsLoading = (state) => state[NAME].resultsIsLoading

export const getSelectedResultIds = (state) => state[NAME].selected.resultIds
export const getCurrentSelectedIndex = (state) => state[NAME].selected.current

const getSelectedResultId = createSelector(
  [getSelectedResultIds, getCurrentSelectedIndex],
  (eventIds, current) => eventIds[current]
)

export const getAllSelectedResults = createSelector(
  [getSelectedResultIds, getResultById],
  (resultIds, byId) => resultIds.map(byId)
)

export const getSelectedCount = createSelector(
  [getSelectedResultIds],
  (selectedIds) => selectedIds.length
)

export const getCurrentSelectedResult = createSelector(
  [getSelectedResultId, getResultById],
  (resultId, byId) => byId(resultId)
)
